<template>
  <div style="display: flex; align-items: center;justify-content: center;">
    <div style="padding: 20px 40px; width: 100%;">
      <el-tabs>
        <el-tab-pane label="短信验证码" >
          <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px">
            <div style="margin: 20px;">
              <el-form-item label="Key(阿里)" prop="nonull">
                <el-input v-model="ruleForm.key" placeholder="请输入阿里的Key"></el-input>
              </el-form-item>
              <el-form-item label="Secret(阿里)" prop="nonull">
                <el-input v-model="ruleForm.secret" placeholder="请输入阿里的Secret"></el-input>
              </el-form-item>
              <el-form-item label="签名名称" prop="nonull">
                <el-input v-model="ruleForm.signname" placeholder="请输入签名名称"></el-input>
              </el-form-item>
              <el-form-item label="模板编码" prop="nonull">
                <el-input v-model="ruleForm.tmpcode" placeholder="请输入模板编码"></el-input>
              </el-form-item>
              <el-form-item label="是否发送" prop="nonull">
                <el-switch
                  v-model="ruleForm.ifsend"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
                </el-switch>
              </el-form-item>
            </div>
            <div class="savebasepanel">
              <el-button type="primary" @click="savesms('ruleForm')">保存信息</el-button>
            </div>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'SMSSet',
    data () {
      var validateNull = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('不允许为空'));
        } else {
          callback();
        }
      }
      return {
        ruleForm: {
          key: '',
          secret: '',
          signname: '',
          tmpcode: '',
          ifsend: false
        },
        rules: {
          nonull: [
            { validator: validateNull, trigger: 'blur' }
          ]
        }
      }
    },
    mounted () {
      that = this
      that.$options.methods.loadsms()
    },
    methods: {
      loadsms () {
        var qstr = 'accountid =' + parseInt(localStorage.getItem('accountid'))
        that.$http({
          url: 'https://api.sqnetsoft.cn/system/qbsms',
          method: 'post',
          data: {
            whereinfo: {String: qstr, Valid: true},
            sorinfo: {String: ' order by id desc', Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              console.log('已成功短信配置数据')
              var smsdata = JSON.parse(res.data.data)
              that.ruleForm.key = smsdata[0].alikey.String
              that.ruleForm.secret = smsdata[0].alisecret.String
              that.ruleForm.signname = smsdata[0].signname.String
              that.ruleForm.tmpcode = smsdata[0].tempcode.String
              if (parseInt(smsdata[0].ifsend) === 0) {
                that.ruleForm.ifsend = false
              } else if (parseInt(smsdata[0].ifsend) === 1) {
                that.ruleForm.ifsend = true
              }
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      savesms(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var ifsendstr
            if (that.ruleForm.ifsend) {
              ifsendstr = 1
            } else {
              ifsendstr = 0
            }
            var adata = {
              accountid: parseInt(localStorage.getItem('accountid')),
              ifsend: parseInt(ifsendstr),
              signtype: parseInt(1),
              signname: {String:that.ruleForm.signname.toString(),Valid:true},
              tempcode: {String:that.ruleForm.tmpcode.toString(),Valid:true},
              alikey: {String:that.ruleForm.key.toString(),Valid:true},
              alisecret: {String:that.ruleForm.secret.toString(),Valid:true}
            }
            that.$http({
              url: 'https://api.sqnetsoft.cn/system/aaubsms',
              method: 'post',
              data: adata,
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  that.$message({
                    type: 'success',
                    message: '更新成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/system/SMSSet.vue